'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect } from 'react';
import { FormLabel } from '../../_internal/FormLabel/FormLabel';
import { useFieldContext } from './FieldContext';
/**
 * Compound member of <Field>. Renders a FormLabel linked to the field's
 * control via the FieldContext id. Consumers only need this in the 10% slot
 * decomposition case — Field's `label` prop is sufficient for standard use.
 */
export function FieldLabel({ children, required }) {
    const ctx = useFieldContext();
    const register = ctx?.registerPart;
    const isRequired = required ?? ctx?.required ?? false;
    useLayoutEffect(() => register?.('label'), [register]);
    return (_jsx(FormLabel, { id: ctx?.ids.label, htmlFor: ctx?.labelFor, required: isRequired, announceRequired: ctx?.groupControl ?? false, children: children }));
}
//# sourceMappingURL=FieldLabel.js.map